import React from "react";
import AIInsight from "../AIInsight";
import SentimentCard from "../SentimentCard";
import CanSlimCard from "../CanSlimCard";

const formatNum = (n) => {
  if (n == null) return "—";
  if (Math.abs(n) >= 1e12) return `${(n / 1e12).toFixed(2)}T`;
  if (Math.abs(n) >= 1e9) return `${(n / 1e9).toFixed(2)}B`;
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(2)}K`;
  return n.toFixed(2);
};

/**
 * Sidebar column for the Asset Detail Chart tab: AI insight, sentiment, CAN
 * SLIM (compact view for stocks), 52-week range and the beginner reminder.
 *
 * Stack order matches the original page so screenreaders + visual hierarchy
 * are preserved.
 */
export default function AssetSidebar({ data, type, range }) {
  return (
    <div className="space-y-6">
      <AIInsight
        symbol={data.symbol}
        name={data.name}
        asset_type={type}
        price={data.price}
        change_pct={data.change_pct}
        range={range}
        points={data.points}
      />

      <SentimentCard assetType={type} symbol={data.symbol} />

      {type === "stock" && <CanSlimCard symbol={data.symbol} variant="compact" />}

      <div className="rounded-2xl bg-white border border-[#EAE6E1] p-6">
        <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#6B7068] mb-3">
          52-week range
        </div>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-[#6B7068]">Year high</span>
            <span className="font-mono-ticker text-[#2A2F2B]">${formatNum(data.info?.year_high)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-[#6B7068]">Year low</span>
            <span className="font-mono-ticker text-[#2A2F2B]">${formatNum(data.info?.year_low)}</span>
          </div>
        </div>
      </div>

      <div className="rounded-2xl bg-[#547A8F]/5 border border-[#547A8F]/20 p-5">
        <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#547A8F] mb-2">
          Beginner reminder
        </div>
        <p className="text-sm text-[#2A2F2B] leading-relaxed">
          UpTick provides educational tools, not financial advice. Past performance doesn't predict future results.
        </p>
      </div>
    </div>
  );
}
